<template>
  <div class="container">
    <div class="row help-wrapper">
      <!-- <header-about /> -->
      <div id="corpo" class="col s12 mensagem-about-geral">
        <h5 class="center">
          Fundamentação Legal
        </h5>
        <div v-if="censo_domain_esp">
          <div id="corpo" class="col s12">
            <template v-for="(item, index) in Object.entries(meta.censo_domain[selectedMunicipio].legal)">
              <h5 class="center" id="manual" v-bind:key="item[0]">
                <span v-html="item[0]"></span> <!-- Títulos -->
              </h5>
              <template v-if="item[1][0].length > 1"> Caso tenha mais de um item na descrição
                <p v-for="(info, index) in item[1]" v-bind:key="info">
                  <span v-html="item[1][index]"></span> <!-- Descrições dos títulos -->
                </p>
              </template>
              <template v-else>
                <p v-bind:key="index" v-html="item[1]"></p> <!-- Descrição dos título  -->
              </template>
            </template>
          </div>
        </div>
        <div v-else>
          <div class="input-field col s12" v-if="showMunicipioSelect === true">
            <select v-model="selectedMunicipio" @change="handlerChange">
              <option :value="null" disabled>Selecione Municipio ou Estado</option>
              <option v-for="(municipio, i) in meta.censo_domain" v-bind:key="i" v-bind:value="i">{{ municipio.nome }}
              </option>
            </select>
          </div>
          <div v-if="selectedMunicipio !== null" id="corpo" class="col s12">
            <template v-for="(item, index) in Object.entries(meta.censo_domain[selectedMunicipio].legal)">
              <h5 class="center" id="manual" v-bind:key="item[0]">
                <span v-html="item[0]"></span> <!-- Títulos -->
              </h5>
              <template v-if="item[1][0].length > 1"> Caso tenha mais de um item na descrição
                <p v-for="(info, index) in item[1]" v-bind:key="info">
                  <span v-html="item[1][index]"></span> <!-- Descrições dos títulos -->
                </p>
              </template>
              <template v-else>
                <p v-bind:key="index" v-html="item[1]"></p> <!-- Descrição dos título  -->
              </template>
            </template>
            <div class="col s12 center">
              <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s8"
                id="abouBtnLogin">
                Voltar
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderAbout from "@/components/HeaderAbout.vue"
import MunicipioSeletor from '../mixins/municipioSeletor'

export default {
  name: 'Ajuda',
  mixins: [MunicipioSeletor],
  components: {
    "header-about": HeaderAbout
  },
  data() {
    return {
      meta: this.$store.state.meta.data,
      active_step: 1,
      last_page: this.$store.state.route.from.fullPath,
      // legalDados: Object.entries(this.$store.state.meta.data.legal),
      selectedMunicipio: null,
      showMunicipioSelect: true,
      censo_domain_esp: false,
      entidade_legal: ""
    }
  },
  methods: {
    initMaterialize() {
      setTimeout(() => M.Collapsible.init((document.querySelectorAll('.collapsible'))), 100)
    },
    handlerChange() {
      if (this.selectedMunicipio !== null) {
        localStorage.setItem('selectedMunicipio', this.selectedMunicipio)
      }
    },
    setup_domain() {
      const meta_data = this.$store.state.meta.data;
      const host = meta_data.host || null;
      if (host) {
        this.censo_domain_esp = true;

        if (meta_data.censo_domain && meta_data.censo_domain[host]) {
          this.domain_name = meta_data.censo_domain[host].nome || "";
          this.entidade_legal = meta_data.censo_domain[host].legal || "";
          localStorage.setItem('selectedMunicipio', host)
        }
        this.entidade_banner = meta_data.censo_domain_banner;
      }
    },
  },
  mounted() {
    this.$root.$emit('stopLoadingHeader')
    this.initMaterialize()
    this.setup_domain()
    this.municipioSeletor()
    setTimeout(() => M.FormSelect.init(document.querySelectorAll('select')), 100)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Legal.vue